/**
 * @desc 站点广告模块
 */
const webSiteBannerList = r => require.ensure([], () => r(require('../views/webSiteBanner/WebSiteBannerList.vue')), 'webSiteBannerList');

export default [
  //站点广告列表
  {
    name: 'webSiteBannerList',
    path: '/webSiteBannerList',
    component: webSiteBannerList,
    meta: { title: '首页大图' },
  },
]